import { Button } from 'ui/button';
import { BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button/constants';
import { ModalBody, ModalHeader, Modal, ModalFooter, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import { useTranslations } from '../hooks/useTranslations';

type Props = {
  onClose: () => void;
  onLeave?: () => void;
  onSave: () => void;
  isModalOpen: boolean;
};

export const UnsavedChangesModal = ({ onClose, onLeave, onSave, isModalOpen }: Props) => {
  const { t } = useTranslations();
  return (
    <Modal
      id="unsavedChangesModal"
      isModalOpen={isModalOpen}
      onClose={onClose}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
    >
      <ModalHeader autoFocus={false}>{t('modal.unsaved.header')}</ModalHeader>

      <ModalBody>{t('modal.unsaved.body')}</ModalBody>

      <ModalFooter>
        {onLeave && (
          <Button onClick={onLeave} size={BUTTON_SIZES.LARGE} variant={BUTTON_VARIANTS.SECONDARY}>
            {t('modal.unsaved.leave')}
          </Button>
        )}

        <Button onClick={onSave} size={BUTTON_SIZES.LARGE}>
          {t('modal.unsaved.save')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
